import { PayloadAction } from '@reduxjs/toolkit';

import { PanAndZoomState } from 'editor/src/store/editorModules/panAndZoom/types';

const setSpreadsDefaultZoomReducer = (state: PanAndZoomState, action: PayloadAction<number[]>) => {
  state.defaultSpreadZoom = action.payload;
};

export default setSpreadsDefaultZoomReducer;
